export interface OrganizationType {
    text: string;
    value: string;
    description: string;
}

export const OtherOrganizationTypeValue = 'Other';
